import { Alert, Button, Text } from '@/ui'
import { light } from '@fortawesome/fontawesome-svg-core/import.macro'
import { useMemo, useState } from 'react'
import { TextColors, TypographyStyles } from '@/styles'
import { TransactionDeleteModal } from '@/features/transactions/TransactionDeleteModal'

export const DetailsAlert = ({
  isUserManualTransaction,
  isManualTransaction,
  transactionId,
  isReconciled,
}: {
  isUserManualTransaction: boolean
  isManualTransaction: boolean
  transactionId: number
  isReconciled: boolean
}) => {
  const [open, setOpen] = useState(false)

  const content = useMemo(() => {
    if (isUserManualTransaction) {
      return {
        icon: light('pencil'),
        body: 'Manually added transaction',
        button: 'Delete',
      }
    } else if (!isUserManualTransaction && isManualTransaction) {
      return {
        icon: light('sync'),
        body: 'Manually added by Heard',
        button: 'Mark as Duplicate',
      }
    } else {
      return {
        icon: light('sync'),
        body: 'Synced transaction',
        button: 'Mark as Duplicate',
      }
    }
  }, [isUserManualTransaction, isManualTransaction])

  return (
    <Alert customIconName={content.icon} variant="default" className="mb-4">
      <div className="flex flex-col gap-4">
        {!isReconciled && (
          <div className="flex flex-row justify-between items-center">
            <Text variant={TypographyStyles.BODY_SM} className="w-5/8">
              {content.body}
            </Text>

            <div className="w-3/8">
              <Button
                className="w-full h-full"
                variant="link"
                onClick={() => setOpen(true)}
              >
                <Text
                  color={
                    isUserManualTransaction
                      ? TextColors.RED
                      : TextColors.DEFAULT
                  }
                  variant={TypographyStyles.BODY_XS}
                >
                  {content.button}
                </Text>
              </Button>
            </div>
          </div>
        )}
        {isReconciled && (
          <Text variant={TypographyStyles.BODY_SM} className="w-full">
            {content.body}
          </Text>
        )}
      </div>
      {open && (
        <TransactionDeleteModal
          open={open}
          close={() => setOpen(false)}
          transactionId={transactionId}
          isManualTransaction={isUserManualTransaction}
        />
      )}
    </Alert>
  )
}
